import React from 'react';

/**
 * Library-owned state for Planting Assistant (plans / plots inventory).
 * Selection + drafts live in usePlantingPlanFlowState.
 */
export function usePlantingPlansLibraryState() {
  const [polygons, setPolygons] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [savedGroups, setSavedGroups] = React.useState([]);
  const [groupsLoading, setGroupsLoading] = React.useState(true);
  const [groupError, setGroupError] = React.useState(null);
  const [deletingGroupId, setDeletingGroupId] = React.useState(null);
  const [editingGroupId, setEditingGroupId] = React.useState(null);
  const [mode, setMode] = React.useState('personal');
  const [presidentClubs, setPresidentClubs] = React.useState([]);
  const [clubsLoading, setClubsLoading] = React.useState(true);
  const [selectedClubId, setSelectedClubId] = React.useState(null);
  const [clubPolygonsById, setClubPolygonsById] = React.useState({});
  const [clubPolygonsLoading, setClubPolygonsLoading] = React.useState(false);
  const [clubPolygonsError, setClubPolygonsError] = React.useState(null);

  return {
    polygons,
    setPolygons,
    loading,
    setLoading,
    error,
    setError,
    savedGroups,
    setSavedGroups,
    groupsLoading,
    setGroupsLoading,
    groupError,
    setGroupError,
    deletingGroupId,
    setDeletingGroupId,
    editingGroupId,
    setEditingGroupId,
    mode,
    setMode,
    presidentClubs,
    setPresidentClubs,
    clubsLoading,
    setClubsLoading,
    selectedClubId,
    setSelectedClubId,
    clubPolygonsById,
    setClubPolygonsById,
    clubPolygonsLoading,
    setClubPolygonsLoading,
    clubPolygonsError,
    setClubPolygonsError,
  };
}
